module.exports = __webpack_public_path__ + "img/profile-selected.61f036f0.svg";